var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBtnCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_41_3713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_41_3713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H24V24H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_41_3713)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C3.35228 2 2 3.35228 2 5V15C2 16.6477 3.35228 18 5 18H15C16.6477 18 18 16.6477 18 15V5C18 3.35228 16.6477 2 15 2H5ZM0 5C0 2.24772 2.24772 0 5 0H15C17.7523 0 20 2.24772 20 5V15C20 17.7523 17.7523 20 15 20H5C2.24772 20 0 17.7523 0 15V5Z",
    fill: "#333333"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5C18 4.44772 18.4477 4 19 4C21.7523 4 24 6.24772 24 9V19C24 21.7523 21.7523 24 19 24H9C6.24772 24 4 21.7523 4 19C4 18.4477 4.44772 18 5 18C5.55228 18 6 18.4477 6 19C6 20.6477 7.35228 22 9 22H19C20.6477 22 22 20.6477 22 19V9C22 7.35228 20.6477 6 19 6C18.4477 6 18 5.55228 18 5Z",
    fill: "#333333"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_41_3713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnCopy);
export default __webpack_public_path__ + "static/media/btn_copy.d7d0ae040a8879b7220a6b4b3f012394.svg";
export { ForwardRef as ReactComponent };